<template>
<div>
<Request/>

</div>
</template>

<script>
import Request from "../../components/OnlineRequest/Request.vue";


export default {
  components: {
   Request
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>